const options = {
  font: {
    nexa: `font-family: 'nexa', cursive, 'Public Sans', sans-serif;`,
    public: `font-family: 'Public Sans', sans-serif;`,
    icon: `font-family: 'Material Icons';`
  },
  color: {
    white: `color: #fff;`,
    black: `color: #000;`,
    darkGrey: `color: rgb(93, 93, 93);`,
    royalBlue: `color: #4765f3;`,
    violet: `color: #0d0831;`,
    coralRed: `color: #ff3240;`,
    salomie: `color: #ffe58d;`,
    athensGray: `color: #f3f4f7;`,
    shamrock: `color: #59d8a1;`,
    current: `color: currentColor;`
  },
  bg: {
    transparent: `background-color: transparent;`,
    white: `background-color: #fff;`,
    black: `background-color: #000;`,
    darkGrey: `background-color: rgb(93, 93, 93);`,
    royalBlue: `background-color: #4765f3;`,
    violet: `background-color: #0d0831;`,
    coralRed: `background-color: #ff3240;`,
    salomie: `background-color: #ffe58d;`,
    athensGray: `background-color: #f3f4f7;`,
    shamrock: `background-color: #59d8a1;`,
    logo: `background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDYiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA0NiA0MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik02LjA0NzgxIDEyLjA5NTZDOS4zODc5MiAxMi4wOTU2IDEyLjA5NTYgOS4zODc5MiAxMi4wOTU2IDYuMDQ3ODFDMTIuMDk1NiAyLjcwNzcgOS4zODc5MiAwIDYuMDQ3ODEgMEMyLjcwNzcgMCAwIDIuNzA3NyAwIDYuMDQ3ODFDMCA5LjM4NzkyIDIuNzA3NyAxMi4wOTU2IDYuMDQ3ODEgMTIuMDk1NloiIGZpbGw9IiNGRjMyNDAiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zOS45NTIxIDEyLjA5NTZDNDMuMjkyMiAxMi4wOTU2IDQ1Ljk5OTkgOS4zODc5MiA0NS45OTk5IDYuMDQ3ODFDNDUuOTk5OSAyLjcwNzcgNDMuMjkyMiAwIDM5Ljk1MjEgMEMzNi42MTIgMCAzMy45MDQzIDIuNzA3NyAzMy45MDQzIDYuMDQ3ODFDMzMuOTA0MyA5LjM4NzkyIDM2LjYxMiAxMi4wOTU2IDM5Ljk1MjEgMTIuMDk1NloiIGZpbGw9IiM0NzY1RjMiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNi4yNTY2IDM2LjcwMjdDMTguODc3OSAzNS4yMzY1IDIxLjI5OTIgMzMuNDQyNyAyMy40NTQgMzEuMzc2OEMyNC43NjQ2IDMwLjEyMTcgMjUuODkyIDI4LjgxNjYgMjYuODY5NCAyNy40ODM4QzI1LjY1ODcgMjcuOTMzNiAyNC4zNTM2IDI4LjE3OCAyMi45OTMgMjguMTc4QzE3LjQ2MTcgMjguMTc4IDEyLjg2MzQgMjQuMDczOSAxMi4wOTcgMTguNzQ4SDAuMTY3OTY5QzAuNzQ1NTM3IDI3LjIxMTYgNS45NDM2NSAzNC42NDIzIDEzLjc2ODYgMzguMDk2NkwxNi4yNTEgMzYuNzA4MkwxNi4yNTY2IDM2LjcwMjdaIiBmaWxsPSIjRkYzMjQwIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjIuOTkxMSA0MC4wNDU5QzIxLjIyNTEgNDAuMDQ1OSAxOS40ODY4IDM5Ljg0NiAxNy43OTMgMzkuNDUxN0MyMC42NTMgMzcuODUyMiAyMy4yNzQzIDM1LjkwODUgMjUuNjM0NiAzMy42NTM4QzMwLjM3NzMgMjkuMTExIDMzLjMwNCAyMy44NDA2IDMzLjg2NDkgMTguODIwMkwzMy44NzYgMTguNzQ4SDQ1LjgxNjFDNDUuMDA1MyAzMC42MzI2IDM1LjA3NTYgNDAuMDUxNCAyMi45OTExIDQwLjA1MTRWNDAuMDQ1OVoiIGZpbGw9IiM0NzY1RjMiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxnIG9wYWNpdHk9IjAuMyI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBvcGFjaXR5PSIwLjMiIGQ9Ik0xNi4yNTYgMzYuNzAzM0MxOC44NzczIDM1LjIzNzEgMjEuMjk4NyAzMy40NDMzIDIzLjQ1MzQgMzEuMzc3NEMyNC43NTg1IDMwLjEyMjMgMjUuODkxNCAyOC44MTcyIDI2Ljg2ODkgMjcuNDg0NEMyNS42NTgyIDI3LjkzNDIgMjQuMzUzMSAyOC4xNzg2IDIyLjk5MjUgMjguMTc4NkMyMi40MjA1IDI4LjE3ODYgMjEuODU5NiAyOC4xMzQxIDIxLjMwOTggMjguMDQ1M0MyMS4yMzIgMjguMTU2NCAyMS4xNDg3IDI4LjI2MTkgMjEuMDY1NCAyOC4zNzI5QzE5LjgzMjUgMjkuOTQ0NiAxOC4zMDUzIDMxLjI4MyAxNi41NzgyIDMyLjI5MzdDMTQuMDA2OSAzMy43OTg4IDExLjAwNzkgMzQuNTU5NiA4LjAzMTI1IDM0LjQ3MDdDOS43MjUwOCAzNS45MzEzIDExLjY1MjIgMzcuMTU4NiAxMy43NzM2IDM4LjA5NzJMMTYuMjU2IDM2LjcwODhWMzYuNzAzM1oiIGZpbGw9IiMwRDA4MzEiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvc3ZnPg=='); background-size: 23px; background-repeat:no-repeat; background-position: center left; padding-left: 30px;`,
  },
  size: {
    sm: `font-size: 10px;`,
    md: `font-size: 12px;`,
    lg: `font-size: 14px;`,
    xl: `font-size: 16px;`,
    xxl: `font-size: 18px;`,
  },
  base: `line-height: 22px; vertical-align: bottom; display: inline-block;`

}


const consoleString = {
  hero: `${options.font.nexa} ${options.color.coralRed} ${options.size.xxl} ${options.base} ${options.bg.logo}`,
  normal: `${options.font.nexa} ${options.color.current} ${options.size.md} ${options.base}`,
  normalHero: `${options.font.nexa} ${options.color.coralRed} ${options.size.md} ${options.base}`,
  error: `${options.font.nexa} ${options.color.coralRed} ${options.size.md} ${options.base}`,
  success: `${options.font.nexa} ${options.color.shamrock} ${options.size.md} ${options.base}`,
};

export {
  consoleString
}
